export default function isNullOrEmpty(value: string | null | undefined): value is null | undefined | "" {
	return value == null || value.length === 0;
}
